import html2canvas from 'html2canvas';
import packageConfig from '../../package.json';
import store from '../store/store';
import axios from 'axios';
import route from '../router';
import vue from 'vue';


function dataURLtoFile(dataurl, filename = 'file') {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${filename}.${suffix}`, {
      type: mime
    })
}

function uploadLog(response){
    let fd=new FormData();
    fd.append('web_url',`${location.protocol}//${location.host}${route.app.$route.fullPath}`)
    fd.append('url',response.config.url);
    fd.append('user_key',vue.$cookies.get('token'));
    fd.append('request_data',response.config.data==undefined?'':response.config.data);
    fd.append('response_data',JSON.stringify(response.data));
    fd.append('nickname',store.state.user_info.nick_name);
    fd.append('version',packageConfig.version);
    fd.append('app_token','HvAoKxYqnK8kvq0N0knqpvY8VHCMzi');

    // axios.post('https://log.yushao.net/api/addlog',fd,{
    //     headers:{
    //       'Content-Type':'multipart/form-data'
    //     }
        
    //   })
    
    return html2canvas(document.body).then(canvas=>{
      let file=dataURLtoFile(canvas.toDataURL('image/png'));
      console.log(file);
      fd.append('screenshot',file);
      return axios.post('https://log.yushao.net/api/addlog',fd,{
        headers:{
          'Content-Type':'multipart/form-data'
        }
        
      })
    }).catch(_=>{
      return axios.post('https://log.yushao.net/api/addlog',fd,{
        headers:{
          'Content-Type':'multipart/form-data'
        }
        
      })
    })
}

let count=0;

function startLoading(url){
  if(url=='/xcx/Login/loginValid') return;
  vue.$vux.loading.show({text:'加载中'});
  count++;
  console.log(count);
}

function endLoading(url){
  setTimeout(()=>{
    closeLoading(url);
  },300)
}

function closeLoading(url){
  if(url=='https://gs.gaishitongshu.cn/xcx/Login/loginValid') return;
  if(count<=0) return;
  count--;
  if(count===0){
    vue.$vux.loading.hide();
  }
}


export {dataURLtoFile,uploadLog,startLoading,endLoading};


// WEBPACK FOOTER //
// ./src/common/tools.js